import { Text, HStack } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import { Pressable } from 'native-base';
import React from 'react';

import { InvestmentStrategyType, sectionContainerOptions } from '../../../constants';

export namespace InvestmentStrategyTypeTabsTypes {
  export type Props = {
    selectedViewOption: InvestmentStrategyType;
    onChange: (value: InvestmentStrategyType) => void;
  };
}

export const InvestmentStrategyTypeTabs: React.FC<InvestmentStrategyTypeTabsTypes.Props> = ({
  onChange,
  selectedViewOption,
}) => {
  return (
    <HStack space={Spacing['stack.xxxs']} backgroundColor={Color['neutral.white']}>
      {sectionContainerOptions.map((option, index) => (
        <Pressable
          key={index.toString()}
          paddingX={Spacing['inset.xs']}
          paddingY={Spacing['inset.quarck']}
          borderRadius="full"
          onPress={() => onChange(option.value as InvestmentStrategyType)}
          backgroundColor={
            Color[
              selectedViewOption === option.value ? 'brand.primary.principal' : 'neutral.lightest'
            ]
          }>
          <Text
            fontSize={Typography['fontsize.md']}
            color={selectedViewOption === option.value ? 'neutral.white' : 'neutral.medium'}>
            {option.label}
          </Text>
        </Pressable>
      ))}
    </HStack>
  );
};
